import { gql } from "@apollo/client/core";

/**
 * This file is generated from the metadata.json file. 
 * ** DO NOT edit this file manually **
 *
 * @example
 * ```
 * this.apollo.mutate({
 *     mutation: REASSIGN_ENGAGEMENT,
 *     variables: {
 *         reassignEngagementRequest: reassignEngagementRequest
 *     }
 * });
 * ```
 */
export const REASSIGN_ENGAGEMENT = gql`
mutation REASSIGN_ENGAGEMENT ($reassignEngagementRequest: ReassignEngagementRequest!) {
    ReassignEngagement(reassignEngagementRequest: $reassignEngagementRequest) {
        response
    }
}`;
